import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useEffect } from "react";
import i18n from "./i18n";
import "./assets/css/DarkTableStyles.css";
import { handleLang } from "./utils/helpers";
import "./assets/css/global.css";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/common/ScrollToTop";
import GoogleAdsTracking from "./components/GoogleAdsTracking";

function App() {
  useEffect(() => {
    handleLang(i18n.language); // first load
    i18n.on("languageChanged", handleLang); // on change
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <GoogleAdsTracking />
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
